import { Link, Outlet, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import "./Request.scss";
function Certified() {
  let navigate = useNavigate();

  // let [tab, setTab] = useState(0);

  // const heighL = useRef();
  // const btnWidth = useRef();
  // useEffect(() => {
  //   heighL.current.style.width = btnWidth.current.offsetWidth + "px";
  //   heighL.current.style.height = btnWidth.current.offsetHeight + "px";
  // });
  // function sliding() {
  //   heighL.current.style.left = btnWidth.current.offsetWidth + "px";
  // }
  // function sliding1() {
  //   heighL.current.style.left = btnWidth.current.offsetWidth * 2 + "px";
  // }
  // function sliding2() {
  //   heighL.current.style.left = 0 + "px";
  // }
  return (
    <>
      {/* <p>
        <Link to="/request/institution">신청기관</Link>
      </p>
      <p>
        <Link to="/request/authinfo">인증신청상세 정보</Link>
      </p>
      <p>
        <Link to="/request/addfile">첨부파일업로드</Link>
      </p> */}

      {/* <div className="tab_btn_wrap">
        <div className="tab_btn">
          <div className="btns_wrap">
            <button
              ref={btnWidth}
              onClick={() => {
                setTab(0);
                sliding2();
                navigate("/request/institution");
              }}
            >
              신청기관
            </button>
            <button
              ref={btnWidth}
              onClick={() => {
                setTab(1);
                sliding();
                navigate("/request/authinfo");
              }}
            >
              인증신청상세 정보
            </button>
            <button
              ref={btnWidth}
              onClick={() => {
                setTab(2);
                sliding1();
                navigate("/request/addfile");
              }}
            >
              첨부파일업로드
            </button>

            <span ref={heighL} className="highlight"></span>
          </div>
        </div>
      </div> */}

      <Outlet></Outlet>
    </>
  );
}

export default Certified;
